/**
 * Is `next` hetzelfde als wat er al in de database staat?
 *
 * Een bootstrap of pull brengt vaak alleen wat hier al staat: de eigen antwoorden
 * van dit apparaat, die net zijn verstuurd. Ze toch wegschrijven kost een lange
 * transactie die elke tik in de opname laat wachten, en elke schrijfactie laat het
 * scherm de hele vragenlijst opnieuw uitrekenen. Daarom wordt alleen weggeschreven
 * wat verschilt.
 *
 * Records zijn gewone objecten, arrays en waarden; de volgorde van de velden telt
 * niet. Een Blob (de bytes van een foto) is alleen gelijk aan dezelfde Blob.
 */
export function sameRecord(stored: unknown, next: unknown): boolean {
    if (Object.is(stored, next)) {
        return true;
    }

    if (
        typeof stored !== 'object' ||
        typeof next !== 'object' ||
        stored === null ||
        next === null ||
        stored instanceof Blob ||
        next instanceof Blob
    ) {
        return false;
    }

    if (Array.isArray(stored) || Array.isArray(next)) {
        return (
            Array.isArray(stored) &&
            Array.isArray(next) &&
            stored.length === next.length &&
            stored.every((value, index) => sameRecord(value, next[index]))
        );
    }

    const before = stored as Record<string, unknown>;
    const after = next as Record<string, unknown>;

    for (const key of new Set([...Object.keys(before), ...Object.keys(after)])) {
        if (!sameRecord(before[key], after[key])) {
            return false;
        }
    }

    return true;
}
